export type FirstAlertsCommunity = {
  id: string;
  name: string;
  created: string;
  internal: boolean;
};

export type GuestFirstAlertsCommunity = {
  id: string;
  name: string;
};

export type ChatSessionHelpful = {
  ms_comm_thread_id: string | null;
  helpful: boolean;
};

export type ChatSessionFeedback = {
  feedback: string;
  ms_comm_thread_id: string | undefined;
  advocate_id: string | undefined;
};

export type AdvocateAvailability = {
  num_online: number;
  num_available: number;
  avatars: string[];
};

export const GuestChatActivityModalStatus = {
  IDLE: 'idle',
  CHAT_CONNECT: 'chat_connect',
  CHAT_LOADING: 'chat_loading',
  CHAT_POST_FEELING: 'chat_post_feeling',
  CHAT_HELPFUL: 'chat_helpful',
  CHAT_REPORTED: 'chat_reported',
  POST_CHAT_SURVEY_FEEDBACK: 'post_chat_survey_feedback',
  CHAT_CONNECT_FAILED_FEEDBACK: 'chat_connect_failed_feedback',
  CONTINUE_CHAT: 'continue_chat',
  END_CHAT: 'end_chat',
} as const;

export type GuestChatActivityModalStatus =
  (typeof GuestChatActivityModalStatus)[keyof typeof GuestChatActivityModalStatus];

export const MoreInfoPages = {
  LEPS: 'leps',
  SERVICES: 'services',
  AREA_SELECT: 'area_select',
  LANGUAGE_SELECT: 'language_select',
  FIRST_ALERTS: 'first_alerts',
};

export type MoreInfoPages = (typeof MoreInfoPages)[keyof typeof MoreInfoPages];

export type GuestResource = {
  name: string;
  description: string | null;
  phone_number: string | null;
  sms?: string[];
  website?: string | null;
};
